// extracted by mini-css-extract-plugin
export default {"imageWrapper":"qmhMm","imageLink":"YJlZ6","image":"kMKJu"};